import { ref } from 'vue'
import { defineStore } from 'pinia'
import { UsersService, type TUser } from '@/types/generated'
import { useLocaleStore, supportedLocales, type Locale } from './localStore'

export const useUserStore = defineStore('userStore', () => {
  const user = ref<TUser>()

  async function fetchUser() {
    try {
      const response = await UsersService.usersRetrieve({ uuid: 'current' })
      user.value = response

      // Only override the browser-detected locale when the user has explicitly
      // chosen a preferred_language. When preferred_language is null the browser
      // locale (from detectInitialLocale) is kept so that e.g. an English-speaking
      // user in a German org sees the UI in English by default.
      const preferredLanguage = response.preferred_language
      console.debug(
        '[userStore] fetchUser complete — preferred_language:',
        preferredLanguage,
        '| effective_language:',
        response.effective_language
      )
      if (preferredLanguage && supportedLocales.includes(preferredLanguage as Locale)) {
        const localeStore = useLocaleStore()
        console.debug(
          '[userStore] user has explicit preference, setting locale to:',
          preferredLanguage,
          '| current store locale:',
          localeStore.getLocale
        )
        localeStore.setLocale(preferredLanguage as Locale)
      }

      return response
    } catch (error) {
      return null
    }
  }

  return {
    user,
    fetchUser
  }
})
